/** Pure helpers shared by the landing code field and the registration page. */

export const INVITE_CODE_QUERY_PARAM = 'invitation_code';

export const normalizeInviteCode = (raw: string): string => raw.trim().toUpperCase();

/** Registration URL a validated code sends the visitor to. */
export const registerUrlForInviteCode = (code: string): string =>
  `/register?${INVITE_CODE_QUERY_PARAM}=${encodeURIComponent(normalizeInviteCode(code))}`;

/** Reads the code the landing page put in the URL. Empty string when absent. */
export const inviteCodeFromSearch = (search: string): string =>
  normalizeInviteCode(new URLSearchParams(search).get(INVITE_CODE_QUERY_PARAM) ?? '');
